import PropTypes from "prop-types"
import React from "react"

import Nav from "../components/nav"

const Header = ({ siteTitle }) => (
  <header className="container mx-auto px-4">
    <Nav />
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
